<template>
  <div id="login" class="app flex-row align-items-start">
    <div class="container-fluid">
      <b-row class="justify-content-start">
        <b-col cols="4" class="app sign-in py-5">
          <div class="title p-5">
            <h1>{{ $t("Login.login") }}..</h1>
            <p class="text-muted">&nbsp;</p>
          </div>
          <div class="px-5">
            <div v-if="errorData" class="error-msg">
              {{ $t(`errors.${errorData.status}.msg`) }}
            </div>
            <b-form class="pb-5">
              <b-input-group class="mb-3">
                <b-form-input
                  type="email"
                  class="form-control"
                  :placeholder="$t('Login.username')"
                  autocomplete="username email"
                  v-model="user.email"
                />
              </b-input-group>
              <b-input-group class="mb-4">
                <b-form-input
                  type="password"
                  class="form-control"
                  :placeholder="$t('Login.password')"
                  autocomplete="current-password"
                  v-model="user.password"
                  v-on:keyup.enter="signIn"
                />
                <!-- <b-button variant="link" class="forgot px-0">{{$t("Login.forgot")}}</b-button> -->
              </b-input-group>
              <b-row>
                <b-col cols="12">
                  <b-button
                    @click="signIn"
                    size="lg"
                    class="primary-btn btn-block mt-4 py-4"
                    >{{ $t("Login.login") }}</b-button
                  >
                  <p class="mt-3">
                    <b-alert v-model="showError" class="error" dismissible>
                      {{ $t("Login.fail") }}
                    </b-alert>
                  </p>
                </b-col>
              </b-row>
            </b-form>
            <b-col cols="12" class="langV">
              <p>v1.30.1</p>
              <LangToggler />
            </b-col>
            <AppStatusLink />
          </div>
        </b-col>
      </b-row>
    </div>
    <Spinner :show="isLoading" />
  </div>
</template>

<script>

const LangToggler = () => import("@/components/LangToggler");
const AppStatusLink = () => import("@/components/AppStatusLink");

export default {
  components: {
    LangToggler,
    AppStatusLink
  },
  data: function() {
    return {
      isLoading: false,
      user: {
        email: '',
        password: ''
      },
      errorData: this.$store.getters["global/errorData"]
    };
  },
  computed: {
    authStatus: function() {
      return this.$store.getters["session/authStatus"];
    },
    showError: function() {
      if (this.authStatus === "error") {
        return true;
      } else {
        return false;
      }
    }
    // errorData: function() {
    //   return this.$store.getters["global/errorData"];
    // }
  },
  methods: {
    signIn: async function() {
      this.isLoading = true;
      try {
        const user = JSON.stringify(this.user);
        // console.log('Login#signIn user ', user)
        await this.$store.dispatch("session/AUTH_LOGIN", user);
        // console.log('Login#signIn this.authStatus ', this.authStatus)
        if (this.authStatus === "success") {
          this.isLoading = false;
          if (this.errorData) {
            // console.log('Login#signIn this.errorData.route_to ', this.errorData.route_to)
            if (this.errorData.route_to == "Login"){
              this.$router.push({ name: "Dashboard" });
            } else {
              this.$router.push({ name: this.errorData.route_to });
            }
          } else {
            this.$router.push({ name: "Dashboard" });
          }
        }
        this.isLoading = false;
      } catch(error) {
        console.log('Error : ', error)
        this.isLoading = false;
        throw "Error";
      }


    }
  }
};
</script>

<style lang="scss" scoped>
#login {
  font-size: 18px;
}
.title {
  justify-self: flex-start;
}
.error-msg {
  padding: 1rem 0;
  color: $warn_red;
  font-weight: bold;
}
.sign-in {
  background-color: $white;
  display: flex;
  justify-content: space-between;
}
.form-control {
  font-size: 18px;
  background-color: transparent;
  color: $b_2;
  border: 0px;
  border-bottom: 1px solid $wg_1;
  border-radius: 0px;
  transition: all 0.3s;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  &:focus {
    @extend %audi;
    border-color: transparent;
    border-bottom: 1px solid $b_1;
    box-shadow: none;
    color: $b_1;
  }
}
.forgot {
  @extend %audi;
  font-size: 18px;
  border-bottom: 1px solid $wg_1;
  border-radius: 0px;
  color: $b_1;
}
.primary-btn {
  font-size: 18px;
  @extend %audi;
}
.error {
  background-color: $warn_red;
  color: $white;
}
.langV {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.app-status-link {
  text-align: right;
}
</style>
